import { Navigate } from "react-router-dom";

var routeProps

function navigationHandler(navigationObject) {
    if(navigationObject){
   
        const navigationRoute = String(navigationObject.navigationRoute).toLowerCase()
        const routeParams = navigationObject.routeProps 

        if(routeParams){
            routeProps = routeParams

            localStorage.setItem('applicantUsername', routeParams.applicantUsername)
        }

        switch(navigationRoute){
              
            case "/": return <Navigate to='/welcome'/>
            case "/welcome": return <Navigate to='/welcome'/>
            case "/home": return <Navigate to='/home'/>
            case "/browser": return <Navigate to='/browser'/>
            case "/borrowingacct": return <Navigate to='/borrowingacct'/>
            case "/newborrowingacct": return <Navigate to='/newborrowingacct'/>
            case "/membertransactions": return <Navigate to='/membertransactions'/>
            case "/register": return <Navigate to='/register'/>
            case "/accountmanagement": return <Navigate to='/accountmanagement'/>
            case "/subscriptionplan": return <Navigate to='/subscriptionplan'/>
            default: return false
        }

    } else {
        return false
    }
}

export { navigationHandler, routeProps }
